import React, { useMemo } from "react";
import Images from "../../asset/images";
import CategorySection from "../../components/CategorySection/CategorySection";
import Banner from "../../layouts/Banner/Banner";
import styles from "./CollectionPage.module.scss"
import classNames from "classnames/bind";
import useCategories from "../../hooks/useCategories";
import { formatCategoryData, filterCategoriesWithProducts } from "../../utils/productUtils";
import { usePageSections } from "../../hooks/usePageSections";
import SectionRenderer from "../../components/SectionRenderer/SectionRenderer";

const cx = classNames.bind(styles);

const CollectionPage = () => {
    // Fetch categories with products (4 products per category for performance)
    const { categories, loading } = useCategories(4);
    const { sections } = usePageSections("collection");

    // Memoize filtered and formatted categories
    const formattedCategories = useMemo(() => {
        if (!categories || !categories.length) {
            return [];
        }

        const validCategories = filterCategoriesWithProducts(categories);
        return validCategories.map(formatCategoryData);
    }, [categories]);

    if (sections?.length) {
        return (
            <div>
                {sections.map((section) => (
                    <SectionRenderer key={section.id} section={section} />
                ))}
            </div>
        );
    }


    // Loading state
    if (loading) {
        return (
            <div className={cx("container__collection")}>
                <div className={cx("collection_banner")}>
                    <Banner showBtn={false} imgSrc={Images.BannerV2Image} className={cx("banner")} />
                </div>
                <div className={cx("collection-products")}>
                    <div className={cx("loading")}>
                        <p>Loading categories...</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={cx("container__collection")}>
            <div className={cx("collection_banner")}>
                <Banner showBtn={false} imgSrc={Images.BannerV2Image} className={cx("banner")} />
            </div>
            <div className={cx("collection-products")}>
                {formattedCategories.map((category) => (
                    <CategorySection
                        key={category.id}
                        category={category}
                    />
                ))}
            </div>
        </div>
    );
};

export default CollectionPage;
